import React from 'react'
import { makeStyles, Tooltip } from '@material-ui/core'
import PropTypes from 'prop-types'

const useStyles = makeStyles(() => ({
  descriptionWrap: {
    '&.MuiTooltip-popper': {
      '& .MuiTooltip-tooltipPlacementTop': {
        minWidth: '30vw',
        backgroundColor: 'var(--dai-color-surface3)',
        color: 'var(--dai-color-text)',
        border: 'var(--dai-border1)',
        boxShadow: 'var(--shadow-md)',
        lineHeight: '18px',
        fontSize: 'var(--font-size-md)',
        padding: '0 var(--padding-md)'
      },
      '& .MuiTooltip-tooltipPlacementBottom': {
        minWidth: '30vw',
        backgroundColor: 'var(--dai-color-surface3)',
        color: 'var(--dai-color-text)',
        border: 'var(--dai-border1)',
        boxShadow: 'var(--shadow-md)',
        lineHeight: '18px',
        fontSize: 'var(--font-size-sm)',
        fontFamily: 'var(--font-serif)',
        padding: '0 var(--padding-md)'
      }
    }
  }
}))

function DaiTooltip ({ children, ...rest }) {
  const classes = useStyles()

  return (
    <Tooltip
      classes={{
        popper: classes.descriptionWrap
      }}
      {...rest}
    >
      {children}
    </Tooltip>
  )
}

DaiTooltip.propTypes = {
  children: PropTypes.node
}

export default DaiTooltip
